import { createTheme } from '@mui/material/styles';

const tokens = {
  paper: '#F8FAFC',
  surface: '#FFFFFF',
  ink: '#0F172A',
  slate: '#475569',
  line: '#E2E8F0',
  signal: '#2563EB',      // Primary Royal Blue
  signalDark: '#1D4ED8',
  signalSoft: '#EFF6FF',
  gold: '#F59E0B',        // Accent Amber
  goldDark: '#D97706',
  goldSoft: '#FFFBEB',
};

const theme = createTheme({
  tokens,
  palette: {
    mode: 'light',
    background: {
      default: tokens.paper,
      paper: tokens.surface,
    },
    primary: {
      main: tokens.signal,
      dark: tokens.signalDark,
      light: tokens.signalSoft,
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: tokens.gold,
      dark: tokens.goldDark,
      light: tokens.goldSoft,
      contrastText: '#FFFFFF',
    },
    text: {
      primary: tokens.ink,
      secondary: tokens.slate,
    },
    divider: tokens.line,
  },
  typography: {
    fontFamily: '"Inter", "Segoe UI", Roboto, sans-serif',
    h1: { fontWeight: 800, letterSpacing: '-0.02em' },
    h2: { fontWeight: 800, letterSpacing: '-0.015em' },
    h3: { fontWeight: 700, letterSpacing: '-0.01em' },
    h4: { fontWeight: 700 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 700 },
    subtitle1: { fontWeight: 600 },
    button: { fontWeight: 600, textTransform: 'none' },
  },
  shape: {
    borderRadius: 10,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: tokens.paper,
          color: tokens.ink,
          overflowX: 'hidden',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          fontWeight: 600,
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          border: `1px solid ${tokens.line}`,
          boxShadow: 'none',
        },
      },
    },
  },
});

export default theme;
